import { createSlice } from '@reduxjs/toolkit'

import { reactivateSubscription } from 'features/billing/actions/reactivate_subscription'

const slice = createSlice({
  name: 'promptToRemoveNonRenewingDowngrade',
  initialState: {
    step: 'prompt',
    loading: false,
    error: null
  },
  reducers: {
    reset: (state) => {
      state.step = 'prompt'
      state.loading = false
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder.addCase(reactivateSubscription.pending, (state) => {
      state.loading = true
    })
    builder.addCase(reactivateSubscription.fulfilled, (state) => {
      state.loading = false
      state.step = 'success'
    })
    builder.addCase(reactivateSubscription.rejected, (state, { payload }) => {
      state.loading = false
      state.step = 'failure'
      state.error = payload
    })
  }
})

export const { reducer, actions: { reset } } = slice
